/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetNdpClientContractsRequest
 */
export interface GetNdpClientContractsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsRequest
     */
    mpk?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsRequest
     */
    contractNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNdpClientContractsRequest
     */
    birthNumber?: string | null;
}

/**
 * Check if a given object implements the GetNdpClientContractsRequest interface.
 */
export function instanceOfGetNdpClientContractsRequest(value: object): value is GetNdpClientContractsRequest {
    return true;
}

export function GetNdpClientContractsRequestFromJSON(json: any): GetNdpClientContractsRequest {
    return GetNdpClientContractsRequestFromJSONTyped(json, false);
}

export function GetNdpClientContractsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNdpClientContractsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mpk': json['mpk'] == null ? undefined : json['mpk'],
        'contractNumber': json['contractNumber'] == null ? undefined : json['contractNumber'],
        'birthNumber': json['birthNumber'] == null ? undefined : json['birthNumber'],
    };
}

export function GetNdpClientContractsRequestToJSON(json: any): GetNdpClientContractsRequest {
    return GetNdpClientContractsRequestToJSONTyped(json, false);
}

export function GetNdpClientContractsRequestToJSONTyped(value?: GetNdpClientContractsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mpk': value['mpk'],
        'contractNumber': value['contractNumber'],
        'birthNumber': value['birthNumber'],
    };
}

